module.exports = __webpack_public_path__ + "2024611:ed75de4ab11883afa87d/img/HomeScreen-Devices-S.1c44e60.png";